<template>
    <div class="card">
        <div class="card-header">
            {{ result.parcel_id }}
        </div>
        <div class="container">
            <ul>
                <li>{{ result.address }}</li>
                <li>{{ result.owner }}</li>
            </ul>
        </div>
        <div class="card-footer">
            <a target="_blank" :href="county_link">Auditor</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ResultCard",
        props: {
            result: Object,
            activeIndex: Number,
            ownIndex: Number,
        },
        data () {
            return {
                county_link: "https://reportallusa.com/cama_redir.php?county_id="+this.result.county_id+"&parcel_id="+this.result.parcel_id
            }
        },
        watch: {
            activeIndex (index) {
                let cardHeader = $('.card-header', this.$el);

                if (this.ownIndex === index) {
                    cardHeader.addClass('active');
                } else {
                    cardHeader.removeClass('active');
                }
            }
        }
    }
</script>

<style scoped>
    .card {
        box-shadow: 4px 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        background-color: white;
        margin-bottom: 10px;
        border-radius: 5px; /* 5px rounded corners */
    }
    /* On mouse-over, add a deeper shadow */
    .card:hover {
        box-shadow: 8px 8px 16px 0 rgba(0,0,0,0.2);
    }
    /* Add some padding inside the card container */
    .container {
        padding: 2px 16px;
    }
    .card-header {
        text-align: center;
        font-size: 1em;
        background-color: #D5E2EE;
        border-bottom: 1px solid black;
        padding: 5px 10px;
        border-radius: 5px 5px 0 0;
        font-weight: 600;
    }
    .card-footer {
        padding: 5px 10px;
        border-top: 1px solid black;
        display: flex;
        justify-content: space-around;
        flex-direction: row;
    }
    .active {
        background-color: #92b2f1;
    }
</style>
